// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 158px;
  height: 147px;
  padding-left: 1px;
}
.note-option,
.highlight-option,
.translation-option,
.speaker-option,
.search-book-option,
.browser-option,
.dict-option,
.wikipedia-option,
.copy-option {
  height: 42px;
  width: 42px;
  font-size: 14px !important;
  line-height: 15px !important;
  opacity: 1;
  text-align: center;
  display: flex;
  box-sizing: border-box;
  cursor: pointer;
  transition: 0.1s;
  /* align-items: center; */
  justify-content: center;
  font-weight: 500;
  margin: 5px;
  margin-bottom: 0px;
  margin-top: 1px;
}
.note-option:hover,
.highlight-option:hover,
.translation-option:hover,
.speaker-option:hover,
.search-book-option:hover,
.browser-option:hover,
.dict-option:hover,
.wikipedia-option:hover,
.copy-option:hover {
  border-radius: 5px;
}

.note-icon,
.translation-icon,
.speaker-icon,
.search-book-icon,
.browser-icon,
.dict-icon,
.baidu-icon,
.bing-icon,
.copy-icon,
.wikipedia-icon,
.highlight-icon {
  line-height: 45px !important;
  font-size: 27px;
}
.translation-icon {
  color: #f16464;
}
.copy-icon {
  color: #ff9900;
}
.highlight-icon {
  color: #5e7fff;
}
.note-icon {
  color: #109870;
}
.speaker-icon {
  color: #b266cb;
  font-size: 30px;
  margin-left: 5px;
}
.search-book-icon {
  color: #6867d1;
}
.browser-icon {
  color: #01b7bc;
  font-size: 27px;
}
.dict-icon {
  color: #2084e8;
  font-size: 25px;
}
.wikipedia-icon {
  font-size: 22px;
  opacity: 0.83;
}
.baidu-icon {
  color: rgb(252, 204, 136);
}
.bing-icon {
  color: rgb(252, 204, 136);
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupOption/popupOption.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;AACA;;;;;;;;;EASE,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;;;;;;;;;EASE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;EAWE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".menu-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 158px;\n  height: 147px;\n  padding-left: 1px;\n}\n.note-option,\n.highlight-option,\n.translation-option,\n.speaker-option,\n.search-book-option,\n.browser-option,\n.dict-option,\n.wikipedia-option,\n.copy-option {\n  height: 42px;\n  width: 42px;\n  font-size: 14px !important;\n  line-height: 15px !important;\n  opacity: 1;\n  text-align: center;\n  display: flex;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: 0.1s;\n  /* align-items: center; */\n  justify-content: center;\n  font-weight: 500;\n  margin: 5px;\n  margin-bottom: 0px;\n  margin-top: 1px;\n}\n.note-option:hover,\n.highlight-option:hover,\n.translation-option:hover,\n.speaker-option:hover,\n.search-book-option:hover,\n.browser-option:hover,\n.dict-option:hover,\n.wikipedia-option:hover,\n.copy-option:hover {\n  border-radius: 5px;\n}\n\n.note-icon,\n.translation-icon,\n.speaker-icon,\n.search-book-icon,\n.browser-icon,\n.dict-icon,\n.baidu-icon,\n.bing-icon,\n.copy-icon,\n.wikipedia-icon,\n.highlight-icon {\n  line-height: 45px !important;\n  font-size: 27px;\n}\n.translation-icon {\n  color: #f16464;\n}\n.copy-icon {\n  color: #ff9900;\n}\n.highlight-icon {\n  color: #5e7fff;\n}\n.note-icon {\n  color: #109870;\n}\n.speaker-icon {\n  color: #b266cb;\n  font-size: 30px;\n  margin-left: 5px;\n}\n.search-book-icon {\n  color: #6867d1;\n}\n.browser-icon {\n  color: #01b7bc;\n  font-size: 27px;\n}\n.dict-icon {\n  color: #2084e8;\n  font-size: 25px;\n}\n.wikipedia-icon {\n  font-size: 22px;\n  opacity: 0.83;\n}\n.baidu-icon {\n  color: rgb(252, 204, 136);\n}\n.bing-icon {\n  color: rgb(252, 204, 136);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
